module.exports = __webpack_public_path__ + "static/media/icon-arrow--down-med-gray.98d65a71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/imgs/icon-arrow--down-med-gray.svg
// module id = 287
// module chunks = 0